import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// Custom CSS styles for Quill editor
const quillStyles = `
  .quill-editor-container {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    overflow: hidden;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  
  .quill-editor-container:focus-within {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }
  
  .quill-editor-container.is-invalid {
    border-color: #dc3545;
  }
  
  .quill-editor-container.is-invalid:focus-within {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  }
  
  .ql-toolbar {
    border: none !important;
    border-bottom: 1px solid #dee2e6 !important;
    padding: 12px 16px !important;
    background-color: #f8f9fa;
    border-radius: 0 !important;
  }
  
  .ql-container {
    border: none !important;
    font-family: inherit !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
  }
  
  .ql-editor {
    padding: 16px !important;
    min-height: 200px !important;
    color: #212529 !important;
  }
  
  .ql-editor.ql-blank::before {
    color: #6c757d !important;
    font-style: italic !important;
  }
  
  .ql-toolbar .ql-formats {
    margin-bottom: 4px !important;
    margin-right: 15px !important;
  }
  
  .ql-toolbar .ql-formats:last-child {
    margin-right: 0 !important;
  }
  
  .ql-toolbar button {
    padding: 4px 6px !important;
    margin: 0 2px !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
  }
  
  .ql-toolbar button:hover {
    background-color: #e9ecef !important;
  }
  
  .ql-toolbar button.ql-active {
    background-color: #0d6efd !important;
    color: white !important;
  }
  
  .ql-toolbar .ql-picker {
    margin: 0 2px !important;
  }
  
  .ql-toolbar .ql-picker-label {
    padding: 4px 8px !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
  }
  
  .ql-toolbar .ql-picker-label:hover {
    background-color: #e9ecef !important;
  }
  
  .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
    background-color: #0d6efd !important;
    color: white !important;
  }
  
  .ql-toolbar .ql-picker-options {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: white !important;
    padding: 4px 0 !important;
  }
  
  .ql-toolbar .ql-picker-item {
    padding: 6px 12px !important;
    transition: background-color 0.15s ease-in-out !important;
  }
  
  .ql-toolbar .ql-picker-item:hover {
    background-color: #f8f9fa !important;
  }
  
  .ql-toolbar .ql-picker-item.ql-selected {
    background-color: #0d6efd !important;
    color: white !important;
  }
  
  .ql-editor h1, .ql-editor h2, .ql-editor h3, .ql-editor h4, .ql-editor h5, .ql-editor h6 {
    font-weight: 600 !important;
    margin-top: 1rem !important;
    margin-bottom: 0.5rem !important;
  }
  
  .ql-editor h1 { font-size: 2rem !important; }
  .ql-editor h2 { font-size: 1.75rem !important; }
  .ql-editor h3 { font-size: 1.5rem !important; }
  .ql-editor h4 { font-size: 1.25rem !important; }
  .ql-editor h5 { font-size: 1.125rem !important; }
  .ql-editor h6 { font-size: 1rem !important; }
  
  .ql-editor p {
    margin-bottom: 1rem !important;
  }
  
  .ql-editor ul, .ql-editor ol {
    padding-left: 1.5rem !important;
    margin-bottom: 1rem !important;
  }
  
  .ql-editor li {
    margin-bottom: 0.25rem !important;
  }
  
  .ql-editor blockquote {
    border-left: 4px solid #dee2e6 !important;
    padding-left: 1rem !important;
    margin: 1rem 0 !important;
    font-style: italic !important;
    color: #6c757d !important;
  }
  
  .ql-editor pre {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    padding: 1rem !important;
    margin: 1rem 0 !important;
    overflow-x: auto !important;
  }
  
  .ql-editor a {
    color: #0d6efd !important;
    text-decoration: underline !important;
  }
  
  .ql-editor a:hover {
    color: #0a58ca !important;
  }
  
  .ql-editor img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 0.375rem !important;
    margin: 1rem 0 !important;
  }
  
  .ql-editor .ql-video {
    width: 100% !important;
    height: 315px !important;
    margin: 1rem 0 !important;
  }
  
  .ql-snow .ql-tooltip {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: white !important;
  }
  
  .ql-snow .ql-tooltip input {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem !important;
    padding: 0.375rem 0.75rem !important;
    font-size: 0.875rem !important;
  }
  
  .ql-snow .ql-tooltip a {
    background-color: #0d6efd !important;
    color: white !important;
    border-radius: 0.25rem !important;
    padding: 0.375rem 0.75rem !important;
    text-decoration: none !important;
    font-size: 0.875rem !important;
    transition: background-color 0.15s ease-in-out !important;
  }
  
  .ql-snow .ql-tooltip a:hover {
    background-color: #0a58ca !important;
  }
  
  @media (max-width: 768px) {
    .ql-toolbar {
      padding: 8px 12px !important;
    }
    
    .ql-toolbar .ql-formats {
      margin-right: 8px !important;
    }
    
    .ql-toolbar button {
      padding: 3px 5px !important;
      margin: 0 1px !important;
    }
    
    .ql-editor {
      padding: 12px !important;
    }
  }
`;

// Inject styles into the document
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = quillStyles;
  document.head.appendChild(styleElement);
}

const JobDescriptionSection = ({ formData, errors, onInputChange, onArrayFieldChange }) => {
  const quillRef = useRef(null);
  const editorRef = useRef(null);

  useEffect(() => {
    if (quillRef.current && !editorRef.current) {
      // Initialize Quill editor
      editorRef.current = new Quill(quillRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
            ['blockquote'],
            ['link'],
            ['clean']
          ]
        },
        formats: [
          'header', 'font', 'size',
          'bold', 'italic', 'underline', 'strike',
          'color', 'background',
          'script',
          'list', 'indent',
          'direction', 'align',
          'blockquote', 'code-block',
          'link', 'image', 'video'
        ],
        placeholder: 'Write a detailed job description including responsibilities, requirements, and benefits...'
      });

      // Set initial content if exists
      if (formData.job_description) {
        editorRef.current.root.innerHTML = formData.job_description;
      }

      // Handle text changes
      editorRef.current.on('text-change', () => {
        const content = editorRef.current.root.innerHTML;
        // Create a synthetic event to match the expected format
        const syntheticEvent = {
          target: {
            name: 'job_description',
            value: content
          }
        };
        onInputChange(syntheticEvent);
      });
    }

    // Cleanup function
    return () => {
      if (editorRef.current) {
        editorRef.current = null;
      }
    };
  }, []);

  // Update editor content when formData changes externally
  useEffect(() => {
    if (editorRef.current && formData.job_description !== editorRef.current.root.innerHTML) {
      editorRef.current.root.innerHTML = formData.job_description || '';
    }
  }, [formData.job_description]);

  return (
    <>
      <div className="row mt-4">
        <div className="col-12">
          <div className="mb-4">
            <label className="form-label fw-semibold text-dark mb-2">Short Description *</label>
            <textarea
              className={`form-control ${errors.short_description ? 'is-invalid' : ''}`}
              name="short_description"
              rows="3"
              value={formData.short_description}
              onChange={onInputChange}
              placeholder="Brief summary of the job position (max 500 characters)"
              maxLength="500"
            />
            {errors.short_description && (
              <div className="invalid-feedback">{errors.short_description}</div>
            )}
            <div className="form-text">
              {formData.short_description ? formData.short_description.length : 0}/500 characters
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="mb-4">
            <label className="form-label fw-semibold text-dark mb-2">Job Description *</label>
            <div className={`quill-editor-container ${errors.job_description ? 'is-invalid' : ''}`}>
              <div 
                ref={quillRef}
                style={{ 
                  minHeight: '200px',
                  backgroundColor: 'white'
                }}
              />
            </div>
            {errors.job_description && (
              <div className="invalid-feedback d-block">{errors.job_description}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default JobDescriptionSection;